import { styled } from '@mui/material';
import { HashLink } from 'react-router-hash-link';

export const UnstyledHashLink = styled(HashLink)({
  textDecoration: 'inherit',
  textDecorationColor: 'inherit',
  color: 'inherit',
});